// extracted by mini-css-extract-plugin
export default {"root":"Filters_root__bWv1W","filterTitle":"Filters_filterTitle__UB0v-","fixedFilterTrigger":"Filters_fixedFilterTrigger__OH1A9","fixedButton":"Filters_fixedButton__8ESEZ"};